import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

import logo from "../img/logo.png";
import SocialFooter from "./SocialFooter";

const Footer = () => {

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <footer className="footer">

        <div className="footer-center">

          <div className="footer-left">
            <Link className="navbar-brand" to="/">
              <img src={logo} alt="Logo" width={100} className="logo-1" />
            </Link>

            <p className="tagline">
              Posjeti nas i doživi novo iskustvo Hrvatske auto scene!
            </p>
          </div>

          <div className="footer-links">
            <a href="/voditelj">Voditelj</a>
            <a href="/galerija">Galerija</a>
            <a href="/lokacija">Lokacija</a>
            <a href="/prijava">Prijava</a>
          </div>

          <div className="footer-right">
            <SocialFooter />
          </div>

        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Develop by: AutoFico.eu</p>
        </div>

      </footer>

      {/* FLOATING BUTTON */}
      <button className="scroll-top" onClick={scrollToTop}>
        ↑
      </button>
    </>
  );
};

export default Footer;